import React from 'react';

import styles from './popover-content.scss';

interface Props {
  children: React.ReactNode;
}

export const RoleActionLinkText: React.StatelessComponent<Props> = ({ children }) => (
  <span className={styles.actionText}>{children}</span>
);
